var ServiceStatusLabels = {
  RUNNING: "Running",
  DEPLOYING: "Deploying",
  SUSPENDED: "Suspended",
  NA: "N/A",
  DELAYED: "Delayed",
  WAITING: "Waiting"
};

module.exports = ServiceStatusLabels;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/ServiceStatusLabels.js